module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD+SURBVGhD7c9LDoIwFIXhJm7BqWNnujnnuga34Nqc6NwheAL3TAAfQB+3yfmTJkBL2y8opZRSSql6a5pm17btxl7rDIg9xh3jVi2GCAC6qsQMEawqzBCB55c9dlWBmUA8MY54vPRf+lxjPiFsOuCTf8wvBMOUX8y/CIYl/jBzEQxL/WCWIhh+KY9Zi2D4tRwmFoJhi/yY2AiGrfJhUiEYtkyPSY1g2DodJheC4Yj4mNwIhqPiYUohGI5cjymNYDh6OcYLguEK8zHeEAxX+R+Dia1HBMOVhpirTY3D5NkWuUIwXK3D4G4PjIN9ng4LTh4RzO73HaGUUkoppdS4EN5ESKz5SHWC7gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collapse-arrow.png
// module id = 231
// module chunks = 0